<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>
<section id="consulta">
  <div class="container" style="max-width: 1300px !important;">
    <div class="row">
      <div class="col-md-12">
        <h2 class="wow fadeInUp">Consulta de Pendientes</h2>
      </div>
      <div class="col-md-6">
        <form class="consulta">
          <div class="form-group cl-white">
            <label for="tipodocumento">Tipo documento</label>
            <select class="form-control" [(ngModel)]="selectedItem" [ngModelOptions]="{standalone: true}"
              >
              <option disabled selected> Seleccione el tipo de documento</option>
              <option value="1">C.C</option>
              <option value="2">C.E</option>
              <option value="3">NIT</option>
            </select>
          </div>
          <div class="form-group cl-white">
            <label for="identificación">Identificación</label>
            <input type="text" class="form-control" placeholder="Ingresa el número de identificación"
              [(ngModel)]="identificationItem" [ngModelOptions]="{standalone: true}">
          </div>
          <button class="btn btn-general btn-white" role="button" (click)="getPendingPayments()">
            <i fa fa-right-arrow></i>Consultar pagos pendientes
          </button>
        </form>
      </div>
      <div class="col-md-12">
        <label class="cliente" *ngIf="showTable"> Señor {{nombreDeudor}} sus deudas actuales son:</label>
        <div *ngIf="showTable" style="overflow-x: scroll;">
          <table class="table table-striped">
            <thead>
              <tr>
                <th><b>Comercio</b></th>
                <th><b>Producto</b></th>
                <th><b>Referencia</b></th>
                <th><b>N° Creditos</b></th>
                <th><b>N° Cuotas</b></th>
                <th><b>Valor Cuota Mes</b></th>
                <th><b>Valor Pago Total</b></th>
                <th><b>Fecha Límite</b></th>
                <th style="display: none;"><b>Extracto</b></th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pendingPayments; let i = index">
                <td>{{item.comercio}}</td>
                <td>{{item.producto}}</td>
                <td>{{item.referencia}}</td>
                <td>{{item.creditos }}</td>
                <td>{{item.cuotas }}</td>
                <td>{{"$ " + (item.valorCuotaMes  | number)}}</td>
                <td>{{"$ " + (item.valorPagoTotal  | number) }}</td>
                <td>{{item.fechaLimitePago  | date:'dd/MM/yyyy'}}</td>
                <td style="display: none;"> <button class="btn btn-general btn-white" role="button" (click)="getExtracto(item)">
                  <i class="fa fa-fw fa-download"></i> Descargar
                </button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group button" *ngIf="showTable">
          <a class="dropdown-item"
            href="https://micrositios.goupagos.com.co/mundo-financiera-sas-mc/login"
            target="_blank">Pague Aquí</a>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
